import {requestAlert} from '@/iamteacherpc/utils/iframe.js';

export default {
    methods: {
        uploadImage(file) {
            this.storeUploadImage({file})
                .catch(e => {
                    requestAlert({title: e.message, okText: this.$t('common_confirm')});
                });
        },

        deleteImage(image) {
            this.storeDeleteImage(image);
        },

        uploadDocument(file) {
            this.storeUploadDocument({file});
        },

        deleteDocument({documentKey}) {
            this.storeDeleteDocument({documentKey});
        },

        retryDocument({documentKey}) {
            this.storeRetryDocument({documentKey});
        },
    }
}
